'use strict';

var $ = jQuery;

var resolution = {
	Set: null,
	Switch: null,
	orientation: null,
	current: null,
	first: true
};

function owlMobileCarousel() {
	if ($('.owl-mobile').length > 0) {
		var $owl2 = $('.owl-mobile');
		if (Modernizr.mq('(max-width: 767px)')) {
			// mobile
			$owl2.removeClass('off').owlCarousel({
				navigation: false,
				slideSpeed: 300,
				paginationSpeed: 400,
				singleItem: false,
				autoPlay: true,
				pagination: true,
				touchDrag: true,
				mouseDrag: false,
				responsive: {
					0: {
						items: 1,
						margin: 0
					},
					540: {
						items: 2,
						margin: 0
					}
				}
			});
		} else {
			$owl2.addClass('off').trigger('destroy.owl.carousel');
			$owl2.find('.owl-stage-outer').children(':eq(0)').unwrap();
		}
	}
}

function openSubSubMenu() {
	if (Modernizr.mq('(min-width: 1024px)')) {
		$('.sub-menu').on('click', '.arrow', function (e) {
			e.preventDefault();
			var $this = $(this),
			    $submenu = $this.next('.sub-sub-menu');
			if ($this.hasClass('open')) {
				$this.removeClass('open');
				$submenu.css('max-height', '0');
			} else {
				$this.addClass('open');
				var h = $submenu.children('ul').outerHeight(true);
				$submenu.css('max-height', h);
				$('body').icons.init('.svg-icon');
			}
		});
		$('.sub-menu li.current_page_item .arrow, .sub-menu li.current_page_ancestor .arrow').click();
	}
}

function openSubMenuOnHover() {
	if (Modernizr.mq('(min-width: 1024px)')) {
		$('.js-main-nav #menu-main-menu > .menu-item > a').on('mouseenter', function (e) {
			e.preventDefault();
			var $this = $(this);
			$this.parent('li').siblings('li').find('.sub-menu').fadeOut(300);
			$this.next('.sub-menu').fadeIn('300');
		});
		$('.js-main-nav #menu-main-menu > .menu-item').on('mouseleave', function (e) {
			e.preventDefault();
			$(this).children('a').next('.sub-menu').fadeOut('300');
		});
	}
}

$.fn.reverse = function () {
	return this.pushStack(this.get().reverse(), arguments);
};

$(function () {
	$('.show-more[data-action!="publicaties"]').click(function (e) {
		e.preventDefault();
		var _this = this,
		    page = $(this).data('page'),
		    action = $(this).data('action');
		$.ajax({
			url: customData.ajaxURL,
			dataType: 'json',
			data: {
				action: 'load_more_items',
				type: action,
				page: page
			}
		}).done(function (data) {
			if (data.html) {
				$('.page-inner .listing').append(data.html);
				$('.page-inner .listing').icons.init('.svg-icon');
				$(_this).data('page', data.nextPage);
				if (data.items < customData.itemsPerPage) {
					$(_this).remove();
				}
			} else {
				$(_this).remove();
			}
		});
	});

	$('.search .page .page-inner .more-search').click(function (e) {
		e.preventDefault();
		var $this = $(this),
		    page = $this.data('page');
		$.ajax({
			url: customData.ajaxURL,
			data: {
				action: 'more_search_results',
				type: $this.data('type'),
				page: page,
				string: $this.data('search')
			}
		}).done(function (data) {
			$this.prev().append(data);
			$this.data('page', page + 1);
			var remainingItems = $this.data('total-results') - $this.prev().find('a').length;
			if (remainingItems > 0) {
				$this.find('a span').text(remainingItems);
			} else {
				$this.remove();
			}
			$('.page-inner .listing').icons.init('.svg-icon');
			if (typeof callback !== 'undefined') {
				callback();
			}
		});
	});

	// Share:
	if ($('.share').length > 0) {
		var $share = $('.share'),
		    $openUp = $share.find('.open-up'),
		    $btn = $('.share > a'),
		    count = $openUp.find('li').length;
		$btn.on('click', function (e) {
			e.preventDefault();
			if (!$openUp.hasClass('active')) {
				$('.share .open-up li').reverse().each(function (i) {
					var el = this;
					setTimeout(function () {
						$btn.addClass('active');
						$openUp.addClass('active');
						$(el).addClass('animated flipInX');
					}, i * 150);
				});
			} else {
				$('.share .open-up li').each(function (i) {
					var el = this;
					setTimeout(function () {
						$(el).addClass('flipOutX');
					}, i * 150);
				});
				setTimeout(function () {
					$openUp.removeClass('active');
					$btn.removeClass('active');
					$('.share .open-up li').each(function (i) {
						var el = this;
						$(el).removeClass('animated flipInX flipOutX');
					});
				}, count * 300);
			}
		});
	}

	// Owl:
	var $owl = $('.owl-partners');
	if ($owl.length > 0) {
		$owl.owlCarousel({
			//items: 5,
			loop: true,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplayHoverPause: true,
			touchDrag: false,
			mouseDrag: false,
			responsive: {
				0: {
					items: 3,
					margin: 40
				},
				768: {
					items: 4,
					margin: 40
				},
				1024: {
					items: 5,
					margin: 50
				},
				1280: {
					items: 6,
					margin: 60
				}
			}
		});
	}

	var $owlDefaultPage = $('.owl-carousel--default-page');
	if ($owlDefaultPage.length > 0) {
		$owlDefaultPage.owlCarousel({
			items: 1,
			autoWidth: true,
			loop: true,
			center: true,
			dots: false,
			mouseDrag: false,
			nav: true,
			navText: ['<i class="svg-icon" data-icon="icon-caret" data-fill="#fff" data-rotate="180"></i>', '<i class="svg-icon" data-icon="icon-caret" data-fill="#fff" data-rotate="0"></i>']
		});
	}

	var $owlPartnersPage = $('.owl-carousel--partners-page');
	if ($owlPartnersPage.length > 0) {
		$owlPartnersPage.owlCarousel({
			items: 1,
			autoWidth: true,
			loop: true,
			center: true,
			dots: false,
			mouseDrag: false,
			nav: true,
			navText: ['<i class="svg-icon" data-icon="icon-caret" data-fill="#fff" data-rotate="180"></i>', '<i class="svg-icon" data-icon="icon-caret" data-fill="#fff" data-rotate="0"></i>']
		});
	}

	// // Same height footer column
	// if (Modernizr.mq('(min-width: 768px)')) {
	// 	// desktop & tablet
	// 	if ($('.footer-column').length > 0) {
	// 		var maxHeight = Math.max.apply(
	// 			null,
	// 			$('.footer-column')
	// 				.map(function () {
	// 					return $(this).height();
	// 				})
	// 				.get()
	// 		);
	// 		$('.footer-column').height(maxHeight);
	// 	}
	// }

	// Sticky Footer
	if (Modernizr.mq('(min-width: 1024px)')) {
		// desktop
		setTimeout(function () {
			var headerHeight = $('.header').height(),
			    footerHeight = $('.footer').outerHeight(true),
			    pageHeight = $('.page-container').height(),
			    pageNewHeight = $(window).height() - headerHeight - footerHeight;
			if (pageHeight < pageNewHeight) {
				$('.page-container').css({ 'min-height': pageNewHeight }); // let op: min-height!!!
			}
		}, 100);
	}

	// SVG icons
	$('body').icons({
		ready: function ready(prop) {}
	});
	$('body').icons.init('.svg-icon');

	// Image loader
	$('.init').imageLoader({
		ready: function ready(prop) {
			//console.log(prop);
		},
		resize: function resize(prop) {
			//console.log('resize');
			//alert('resize');
		}
	});

	// Scroller
	setTimeout(function () {
		// settimeout is nodig voor verspringen menu bij laden pagina.
		$(window).scroller({
			items: function items() {
				if (Modernizr.mq('(min-width: 768px)')) {
					scroll.header.init();
				}
			},
			calculation: function calculation(pos) {
				if (Modernizr.mq('(min-width: 768px)')) {
					scroll.header.calculation(pos);
				}
			},
			animation: function animation(pos) {
				if (Modernizr.mq('(min-width: 768px)')) {
					scroll.header.animation(pos);
				}
			},
			resize: function resize() {
				if (Modernizr.mq('(min-width: 768px)')) {
					scroll.header.resize();
				}
			}
		});
	}, 100);

	// switch grid / resize functions
	resolution.Set = function () {
		var newResolution;
		if (Modernizr.mq('(max-width: 767px)')) {
			newResolution = 'mobile';
		} else if (Modernizr.mq('(max-width: 1279px)')) {
			newResolution = 'tablet';
			if (Modernizr.mq('(max-width: 1023px)')) {
				newResolution += ' portrait';
			} else {
				newResolution += ' landscape';
			}
		} else {
			newResolution = 'desktop';
			if (Modernizr.mq('(min-width: 1440px)')) {
				newResolution += ' wide';
			}
		}
		if ($('html').hasClass('no-borderradius')) {
			grid += ' IE8';
		}
		if (newResolution !== resolution.current) {
			var resolutionClasses = ['mobile', 'tablet', 'desktop', 'wide', 'IE8', 'portrait', 'landscape'];
			$.each(resolutionClasses, function (i, v) {
				$('html').removeClass(v);
			});
			resolution.current = newResolution;
			$('html').addClass(resolution.current);
			resolution.Switch(resolution.current);
		}
	};
	$('#setGrid').ready(function () {
		resolution.Set();
	});

	// switch grid / resize functions
	resolution.Switch = function (size) {
		if (resolution.first === true) {
			resolution.first = false;
			defaultResets.init();
			search.init();
			loadVideo.init();
			mobileNav.init();
			owlMobileCarousel();
			filter.init();
			openSubSubMenu();
			slideDown.init();
			openSubMenuOnHover();
		} else {
			owlMobileCarousel();
			openSubSubMenu();
			openSubMenuOnHover();
			$('body').icons.init('.svg-icon');
		}
	};

	var resizeTimeout;
	$(window).resize(function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			resolution.Set();
			$('.init').imageLoader.resize();
			$('body').icons.init('.svg-icon');
		}, 100);
	});

	resolution.orientation = function () {};
	window.addEventListener('orientationchange', resolution.orientation);

	resolution.Set();
});

$('.slidedown li.sd-item').click(function () {
	$(this).find('.sd-content').slideToggle();

	if ($(this).hasClass('open')) {
		$(this).removeClass('open').addClass('closed');
	} else {
		$(this).addClass('open');
	}
});

$(window).on('load', function () {
	if (Modernizr.mq('(min-width: 768px)')) {
		if ($('.footer-column').length > 0) {
			var maxHeight = Math.max.apply(null, $('.footer-column').map(function () {
				return $(this).height();
			}).get());
			$('.footer-column').height(maxHeight);
		}
	}
});

// Function to adjust the size of the squares
function adjustSquareSize() {
	document.querySelectorAll('.image-wrap').forEach(function (item) {
		var height = item.querySelector('img').offsetHeight;
		var size = height / 2.5;

		// Set the variable for square size
		item.style.setProperty('--square-size', size + 'px');

		// Adjust the container height to maintain the stacking
		item.parentNode.querySelector('.square-container').style.height = height + 'px';
	});
}

adjustSquareSize();

// Adjust the size when the window is resized
window.onresize = adjustSquareSize;